import { render } from "./Programs.vue?vue&type=template&id=4920a63e"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__